import { Component, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA, MdDialog } from '@angular/material';
import { ShareBudget } from 'app/components/modal/dialog-share-budget/dialog-share-budget.model';
import { DestinationTravelPolicy } from 'app/model/products/hotel/hotel.model';
import { DialogBudgetLimitDetailComponent } from '../dialog-budget-limit-detail/dialog-budget-limit-detail.component';

@Component({
  selector: 'act-dialog-budget-limit-mobile',
  templateUrl: './dialog-budget-limit-mobile.component.html',
  styleUrls: ['./dialog-budget-limit-mobile.component.scss']
})
export class DialogBudgetLimitMobileComponent {

  public name = 'dialog-budget-limit-mobile';
  public appliedCoBudget = false;

  constructor(
    private dialogRef: MdDialogRef<DialogBudgetLimitMobileComponent>,
    private dialog: MdDialog,
    @Inject(MD_DIALOG_DATA) private data: {
      budgetBooker: number
      budgetCoBooker: number,
      destinationTravelPolicyBooker: DestinationTravelPolicy[];
      destinationTravelPolicyCoBooker: DestinationTravelPolicy[];
      itemList;
      itemListCoBooker;
      template;
      textAverageBudget;
      shareBudget: ShareBudget;
    }
  ) {
    this.appliedCoBudget = data.destinationTravelPolicyBooker.some(tp => tp.appliedCoBudget);
  }

  onClose() {
    this.dialogRef.close();
  }

  onMoreDetail() {
    this.dialog.open(DialogBudgetLimitDetailComponent, {
      data: {
        budgetBooker: this.data.budgetBooker,
        budgetCoBooker: this.data.budgetCoBooker,
        destinationTravelPolicyBooker: this.data.destinationTravelPolicyBooker,
        destinationTravelPolicyCoBooker: this.data.destinationTravelPolicyCoBooker,
        isShareBudget: !!this.data.shareBudget
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/budget-limit/dialog-budget-limit/dialog-budget-limit-mobile/dialog-budget-limit-mobile.component.ts